import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';
import { initDB } from 'react-indexed-db';
import { dbConfig } from './functions/dbConfig';
import { ConfigProvider } from 'antd';
import { PRIMARY_COLOR } from './common/ThemeConstants';
import { Toaster } from "./components/ui/toaster";
import { Toaster as Sonner } from "./components/ui/sonner";
import { TooltipProvider } from "./components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { resetRefreshCounter } from './utils/refreshLoopDetector';

import 'antd/dist/antd.variable.min.css';
import './App.css';

ConfigProvider.config({
  theme: {
    primaryColor: PRIMARY_COLOR, // "#4561B9",
  },
});

initDB(dbConfig);

const queryClient = new QueryClient();

const App = () => {
  // Reset refresh counter when app successfully mounts
  // This indicates the app initialized without triggering a refresh loop
  useEffect(() => {
    // Small delay to ensure app is fully initialized
    const timer = setTimeout(() => {
      resetRefreshCounter();
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>

      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
